.productSortButton {
  margin-left: auto;
}

.productSortButton select {
  color: var(--colors-text-main);
  background-color: var(--btn-tertiary-background-color);
  border-color: var(--btn-tertiary-border-color);
  border-width: var(--btn-tertiary-border-width);
  min-width: 80px;
}

.productFilterPopoverTarget {
  white-space: nowrap;
  border-radius: var(--border-radius-lg);
  margin-bottom: 16px;
}

.sortContainer {
  &:first-child {
    margin-top: 8px;
  }

  &:last-child {
    margin-bottom: 8px;
  }
}

.sortLabel {
  display: flex;
}

.labelContainer {
  margin-right: auto;
}

.checkIconContainer {
  margin-left: auto;
  margin-right: 24px;
}
